import lazyLoading from './lazyLoading'

export default {
  path: '/reports',
  meta: {
    auth: true,
    icon: 'fa-bar-chart',
    expanded: false,
    label: 'Reports'
  },
  component: lazyLoading('reports', true),

  children: [
    {
      name: 'Reports',
      path: '',
      component: lazyLoading('reports/Default'),
      meta: {
        link: 'reports/Default.vue'
      }
    },
    {
      name: 'User',
      path: 'user',
      meta: {
        description: 'Single User report',
        link: 'reports/User.vue'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/reports.js